import React, { useState } from 'react';
import { FiX, FiMessageSquare } from 'react-icons/fi';

export default function ReplyModal({ isOpen, onClose, onReply, comment }) {
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reply.trim()) return;
    setLoading(true);
    await onReply(reply);
    setLoading(false);
    setReply('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-full max-w-lg">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <FiMessageSquare /> Reply to Comment
          </h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <FiX className="w-5 h-5" />
          </button>
        </div>
        
        {comment && (
          <div className="p-6 border-b bg-gray-50">
            <p className="text-sm text-gray-500 mb-1">Original comment:</p>
            <p className="text-gray-700">"{comment.comment}"</p>
            <p className="text-xs text-gray-400 mt-2">— {comment.name}</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="p-6">
          <textarea
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            placeholder="Write your reply..."
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-500"
            required
          />
          
          <div className="flex justify-end space-x-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !reply.trim()}
              className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send Reply'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
